import { Injectable } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { findTopmostDialog } from './find-topmost-dialog';

interface DynamicDialogEscapeEntry {
  readonly ref: DynamicDialogRef;
  readonly host: HTMLElement;
}

@Injectable({ providedIn: 'root' })
export class DynamicDialogEscapeStack {
  private entries: readonly DynamicDialogEscapeEntry[] = [];

  register(ref: DynamicDialogRef, host: HTMLElement): void {
    this.entries = [...this.entries, { ref, host }];
    ref.onDestroy.subscribe(() => this.unregister(ref));
  }

  closeTopmost(): boolean {
    const topmostDialog = findTopmostDialog();
    if (topmostDialog === null) return false;
    const entry = this.entries.find((candidate: DynamicDialogEscapeEntry) => candidate.host.contains(topmostDialog));
    if (entry === undefined) return false;
    entry.ref.close();
    return true;
  }

  private unregister(ref: DynamicDialogRef): void {
    this.entries = this.entries.filter((entry: DynamicDialogEscapeEntry) => entry.ref !== ref);
  }
}
